/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Directive,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
  input,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { highlightInvalidControls } from '../../utils/form/form.utils';

@Directive({
  selector: '[appFormSubmit]',
  standalone: true,
})
export class FormSubmitDirective implements OnInit {
  readonly formGroup = input<UntypedFormGroup | null>(null);
  @Output() submitted: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
    if (!this.formGroup()) {
      console.error('appFormSubmit must be passed formGroup');
    }
  }

  @HostListener('ngSubmit', ['$event'])
  onNgSubmit = () => {
    const formGroup = this.formGroup();
    if (!formGroup || formGroup.disabled) {
      return;
    }

    if (formGroup.invalid) {
      highlightInvalidControls(formGroup);
      return;
    }

    return this.submitted.emit(formGroup.getRawValue());
  };
}
